import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import mainContainer from '../components/mainContainer'
import helpCenter from '../components/helpCenter'
import linghouAgreement from '../components/linghouAgreement'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/mainContainer',
    children: [{
      path: 'mainContainer',
      component: mainContainer
    },
    {
      path: 'helpCenter',
      component: helpCenter
    },
    {
      path: 'agreement',
      component: linghouAgreement
    }
    ]
  }],
  linkActiveClass: '/mainContainer'
})



// WEBPACK FOOTER //
// ./src/router/index.js